<template>
	<div class="yixiaolie" style="font-size: 12px;">
		<div class="header">
			<div style="cursor: pointer;">
				<div class="borziBtn" v-bind:class="{active:(cepingtai==2)}" @click="ceping(2)">已预约</div>
				<div class="borziBtn" style="margin-left: 10px" v-bind:class="{active:(cepingtai==3)}" @click="ceping(3)">已咨询</div>
			</div>
			<div class="shenziBtn" @click="xinjianyuyue" style="cursor: pointer;">新建预约</div>

			<div class="sousuok" style="width: 200px;border: 1px solid #E6BE8A;border-radius: 5px;">
				<el-input size="mini" placeholder="请输入姓名、电话搜索" v-model="cha" @keyup.native="jiansuo">
					<i class="el-icon-search el-input__icon" slot="suffix"></i>
				</el-input>
			</div>

		</div>
		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>类型</th>
						<th>家长姓名</th>
						<th>会员姓名</th>
						<th>别名</th>
						<th>手机号</th>
						<th>预约测评时间</th>
						<th>预约测评师</th>
						<th>性别</th>
						<!-- <th>生日</th> -->
						<th>月龄</th>
						<th>课时</th>
						<th>状态</th>
						<th v-if="cepingtai==2">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(fe,index) in list">
						<!--v-for="(fe,index) in fen"-->
						<td v-cloak>{{index+1}}</td>
						<td v-cloak>{{fe.hy_zt}}</td>
						<td v-cloak>{{fe.jz_name}}</td>
						<td style="cursor: pointer" @click="baobut(fe)" v-cloak>{{fe.baobao_name}} </td>
						<td style="cursor: pointer" @click="baobut(fe)" v-cloak>{{fe.baobao_name2}}</td>
						<td v-cloak>{{fe.phone1 != null ? fe.phone1 : fe.phone2}}</td>
						<td v-cloak>{{fe.yy_time}}</td>
						<td v-cloak>{{fe.username}}</td>
						<td v-cloak>{{fe.baobao_sex}}</td>
						<!-- <td v-cloak>{{fe.baobao_birthday}}</td> -->
						<td v-cloak>{{fe.yueling}}</td>
						<td v-cloak>{{fe.y_keshi}}</td>

						<!--<td v-if="fe.cp_status==4" style="color:#ff797c;cursor: pointer"  >{{fe.cp_zt}}</td>  &lt;!&ndash;未完成&ndash;&gt;-->
						<td v-if="fe.cp_status==2" style="color:green;cursor: pointer" @click="tiaoyex(fe)" v-cloak>{{fe.cp_zt}}</td>
						<td v-if="fe.cp_status==3" style="color:#00cce4;" v-cloak>{{fe.cp_zt}}</td>
						<!--新测评-->
						<td v-if="fe.cp_status==1" style="color:rgb(124, 114, 193);cursor: pointer" @click="history(fe.list_id)" v-cloak>{{fe.cp_zt}}</td>
						<td v-if="fe.cp_status==4" style="color:#ff797c;" v-cloak>{{fe.cp_zt}}</td>
						<td v-if="cepingtai==2" style="cursor: pointer;">
							<span @click="qie(fe.phone1 != null ? fe.phone1 : fe.phone2,fe.list_id)">切换宝宝</span>
							<span @click="cancel(fe.list_id)" style="color: red;margin-left: 15px;">取消预约</span>
						</td>
					</tr>
					<tr>
						<td v-if="list==''" colspan="13">暂无数据</td>
					</tr>
				</tbody>
			</table>
		</div>
		<p style="padding: 20px 10px 0;color: #999;font-size: 14px">共有<span>{{biaonum}}</span>条数据，当前第 <span>{{page}} </span>
			页共 <span>{{pagetotal}}</span>页</p>
		<div class="table-bottom">
			<div>
				<el-pagination @current-change="tan" :page-size="pageone" background :total="biaonum" layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<!-- 修改会员姓名 -->
		<el-dialog custom-class="dialog2" :visible.sync="dialog0" width="33%" center>
			<div style="position: relative;background-color: #E6BE8A;">
				<span style="position: absolute;top: -7px;left: 44%;z-index: 999;font-size: 16px;font-weight: bold;">宝宝信息</span>
			</div>
			<div style="height: 35px;"></div>
			<div class="form_box" style="margin-bottom:15px;">
				<label>会员姓名:</label>
				<el-input v-model="xiu_bao" style="width:80%;" size="small" placeholder="修改会员姓名"></el-input>
			</div>
			<div class="form_box" style="margin-bottom:15px;">
				<label>会员别名:</label>
				<el-input v-model="xiu_bao2" style="width:80%;" size="small" placeholder="修改会员别名"></el-input>
			</div>
			<div class="form_box" style="margin-bottom:15px;">
				<label>会员生日:</label>
				<el-date-picker v-model="xiu_bao3" value-format="yyyy-MM-dd" type="date" size="small" placeholder="选择会员生日"></el-date-picker>
			</div>
			<div class="form_box">
				<label>会员性别:</label>
				<el-radio v-model="xiu_bao4" label="男">男</el-radio>
				<el-radio v-model="xiu_bao4" label="女">女</el-radio>
			</div>
			<div class="form_box"></div>
			<span slot="footer" class="dialog-footer">
				<el-button type="warning" size="medium" @click="xiu()" round>确认修改</el-button>
			</span>
		</el-dialog>
		<!-- 切换宝宝 -->
		<el-dialog title="修改宝宝" :visible.sync="dialog1" width="35%" center>
		  <div class="dialog-type">
			  <p style="padding: 15px 20px;font-size: 15px;">请选择宝宝测评：</p>
			  <div style="padding: 0px 20px;font-size: 15px;">
				  <el-radio-group v-model="h_id" >
					<el-radio v-for="(i,iii) in h_list" :key="iii" :label="i.user_id" @change="h_but()" class="radios">{{i.baobao_name}}</el-radio>
				  </el-radio-group>
			  </div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				biaonum: 0,
				pageone: 10,
				centre_id: '',
				list: '',
				page: 1,
				pagetotal: '',
				cepingtai: 2,
				cha: '',
				create: "",
				token: '',
				user_id: '',
				xiu_bao: '',
				xiu_bao2: '',
				xiu_bao3:'',
				xiu_bao4:'',
				dialog0: false,
				dialog1:false,
				h_id:'',
				h_list:'',
				list_id:'',
			}
		},
		methods: {
			cancel(i){
				let that = this
				that.$confirm('确认取消已预约测评?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					that.get_cancel(i)
				}).catch(() => {
					console.log('取消删除')
				});
			},
			get_cancel(i){
				let that = this
				$.ajax({
					url: process.env.apiUrl + "saas/ceping/del_query",
					type: "post",
					dataType: "json",
					data: {
						token: that.token,
						list_id:i,
					},
					success: function(res) {
						if(res.status == 1){
							that.get_data()
							that.$message.success(res.msg)
						}else{
							that.$message.error(res.msg)
						}
					},
					fail:function(err){
						console.log(err)
					}
				});
			},
			// baobut(fe.baobao_name,fe.user_id,fe.baobao_name2,fe.cp_time,fe.user_id,fe.baobao_sex)
			baobut: function(e) {
				if(this.cepingtai==2){
					this.dialog0= true
					this.xiu_bao=e.baobao_name
					this.xiu_bao2=e.baobao_name2
					this.xiu_bao3=e.baobao_birthday
					this.xiu_bao4=e.baobao_sex
					this.user_id =e.user_id
				}
			},
			xiu: function() {
				let self = this;
				if(this.xiu_bao==""||this.xiu_bao==null){
					self.$message.error("会员姓名不能为空");
					 return
				}
				// if(this.xiu_bao2==""||this.xiu_bao2==null){
				// 	self.$message.error("会员别名不能为空");
				// 	 return
				// }
				if(this.xiu_bao3==""||this.xiu_bao3==undefined){
					self.$message.error("请选择会员生日");
					 return
				}
				if(this.xiu_bao4==""||this.xiu_bao4==null){
					self.$message.error("请选择会员性别");
					return
				}
				$.ajax({
					url: process.env.apiUrl + "saas/yuyue/update_name",
					type: "post",
					dataType: "json",
					data: {
						token: self.token,
						babao_name2:self.xiu_bao2,
						babao_name:self.xiu_bao,
						user_id:self.user_id,
						baobao_time:self.xiu_bao3,
						baobao_sex:self.xiu_bao4,
					},
					success: function(data) {
						if(data.status==1){
							self.ceping(2)
							self.dialog0 = false
							self.$message({
							  message:data.msg,
							  type: 'success'
							});
						}else{
							self.$message.error(data.msg);
						}
					}
				});
			},
			qie:function(p,id){
				let self = this;
				this.dialog1=true
				this.list_id=id
				$.ajax({
					url: process.env.apiUrl + "saas/yuyue/detail",
					type: "post",
					dataType: "json",
					data: {
						token: self.token,
						phone:p,
					},
					success: function(data) {
						self.h_list=data.data
					}
				});
			},
			h_but:function(){
				let self = this;
				$.ajax({
					url: process.env.apiUrl + "saas/yuyue/qiehuan",
					type: "post",
					dataType: "json",
					data: {
						token: self.token,
						list_id:self.list_id,
						user_id:self.h_id,
					},
					success: function(data) {
						if(data.status==1){
							self.ceping(2)
							self.dialog1 = false
							self.$message({
							  message:data.msg,
							  type: 'success'
							});
						}else{
							self.$message.error(data.msg);
						}

					}
				});
			},
		    history: function(listid) {

				this.$router.push({
					name: 'historylc',
					query: {
						listid: listid
					}
				})
			},
			tiaoyex: function(e) {
				let self=this
				if(e.baobao_name&&e.yueling){
                    self.$router.push({
					name: 'cpaddmeslc',
					query: {
						iid: e.list_id
					}
				})
				}else{
                    self.baobut(e)
// 					setInterval(function () {
// 					  self.u_id=e.user_id
// 					}, 300);
				}

			},
			xinjianyuyue: function() {

				this.$router.push({
					name: 'yuyuelie'
				})

			},
			jiansuo: function() {
				let self = this;
				self.page = 1;
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/yx_index`,
					type: "post",
					dataType: "json",
					data: {
						token:self.token,
						cp_status: self.cepingtai,
						page: self.page,
						search: self.cha
					},
					success: function(data) {
						self.biaonum = Number(data.map.count);
						self.pageone = Number(data.map.pageone);
						self.list = data.data;
						self.pagetotal = data.map.pagetotal
					}
				});
			},
			tan: function(e) {
				let self = this
				self.page = e
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/yx_index`,
					type: "post",
					dataType: "json",
					data: {
						token: self.token,
						cp_status: self.cepingtai,
						page: self.page,
						search: self.cha,
					},
					success: function(data) {
						self.biaonum = Number(data.map.count);
						self.pageone = Number(data.map.pageone);
						self.list = data.data;
						self.pagetotal = data.map.pagetotal
					}
				});
			},
			ceping: function(a) {
				let self = this;
				self.cepingtai = a;
				self.page = 1;
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/yx_index`,
					type: "post",
					dataType: "json",
					data: {
						token: self.token,
						cp_status: self.cepingtai,
						page: self.page,
						search: self.cha
					},
					success: function(data) {
						self.biaonum = Number(data.map.count);
						self.pageone = Number(data.map.pageone);
						self.list = data.data;
						self.pagetotal = data.map.pagetotal
					}
				});
			},
			//获取表格数据
			get_data(){
				let self = this;
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/yx_index`,
					type: "post",
					dataType: "json",
					data: {
						token: self.token,
						cp_status: 2
					},
					success: function(data) {
						self.biaonum = Number(data.map.count);
						self.pageone = Number(data.map.pageone);
						self.list = data.data;
						self.pagetotal = data.map.pagetotal
					}
				});
			},

		},
		mounted: function() {
			this.centre_id = $.cookie('centre_id');
			this.create = $.cookie('create_user')
			this.token = $.cookie('token')

			this.get_data()
		}

	}
</script>

<style scoped>
	body .yixiaolie {
		/*font-size: 18px;*/
	}

	.borziBtn.active {
		background: #E6BE8A;
		color: #fff;
		border: none;
	}

	.header {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.tablebtnBox {

		display: flex;
		justify-content: space-between;
	}

	.tableBox {
		padding: 0 10px;

	}

	body,
	p {
		margin: 0;
		padding: 0;
		font-size: 11px;
	}

	.boxr {
		width: 224px;
		height: 54px;
		/*line-height: 1.08;*/
		/*background: green;*/
		box-sizing: border-box;
		padding-left: 20px;
		display: flex;
		display: -webkit-flex;
		align-items: center;
	}

	.mainBox {
		display: flex;
		display: -webkit-flex;
		flex: 1;


	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.leftBox {
		width: 70px;
		height: 100%;
		background: #E6BE8A;
		border-radius: 10px 0 0 10px;
		box-sizing: border-box;
		padding-top: 30px;
		padding-bottom: 30px;

	}

	.rightBox {
		flex: 1;
		flex-direction: column;
	}

	.mainbox {
		flex: 1;
	}

	.bottombox {
		height: 40px;
		justify-content: center;
		align-items: center;
		color: #666;
		width: 100%;
		background: #f1f1f1;
	}

	.mainhead {
		display: flex;
		display: -webkit-flex;
		height: 43px;
		background: #f1f1f1;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 8px;
		padding-right: 8px;
	}

	nav {
		width: 100%;
		height: auto;
		overflow-y: scroll;
		overflow-x: visible;
	}

	.navlist {
		height: 55px;
		justify-content: center;
		align-items: center;

	}

	.tubiaoc {
		display: inline;
		text-align: center;
	}

	.navimg {
		width: 28px;
		height: 28px;
	}

	.navinfo {
		color: #fff;
		margin-top: -2.5px;
	}

	.logotitle {
		font-size: 14px;
		color: #6355a2;
		margin-left: 15px;
		font-weight: 700;
		margin-top: 13px;
		letter-spacing: 0.5px;
	}

	.mainbox2 {
		flex-direction: column;
		flex: 1;
	}

	.headleft {
		height: 24px;
	}

	.headright {
		height: 24px;
		justify-content: flex-end;
		align-items: center;
	}

	.jumpindex {
		width: 55px;
		height: 24px;
	}

	.centername {
		line-height: 24px;
		margin-left: 10px;
	}

	.HeadPurBtn {
		padding: 3px 9px;
		border-radius: 13px;
		background: #E6BE8A;
		color: #fff;
	}

	.HeadHelpBtn {
		width: 50px;
		margin-left: 15px;
	}

	.inner_body {
		background: #f1f1f1;
	}


	.tanchuang2 .el-dialog__body {
		padding: 15px;
		height: 270px;
		overflow-y: scroll;
	}

	.tanchuang2 .el-dialog__footer {
		border-top: 1px solid #e5e5e5;
	}

	.clearfloat:after {
		display: block;
		clear: both;
		content: "";
		visibility: hidden;
		height: 0
	}

	.clearfloat {
		zoom: 1
	}

	.yongtou {
		float: right;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yongtou2 {
		float: left;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yLbox {
		margin-right: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #fdb06a;
		border-radius: 10px;
	}

	.yLbox2 {
		margin-left: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #eee;
		border-radius: 10px;
	}

	.fasongBtn {
		width: 130px;
		height: 32px;
		text-align: center;
		line-height: 32px;
		color: #fff;
		font-size: 16px;
		border-radius: 16px;
		float: left;
		cursor: pointer;
		margin-top: 20px;
		background: #fdb06a;
		box-shadow: #f7dcc4 3px 5px 10px;
	}

	.genjilist {
		list-style: none;
		padding: 0;
	}


	.genjilist li {
		height: 35px;
		box-sizing: border-box;
		line-height: 35px;
		text-align: center;
		color: #E6BE8A;
		background: #f1f1f1;
		border-bottom: 1px solid #d2cef3;
	}
	.radios{
		margin-left:0;
		padding-right: 30px;
		padding-bottom: 20px;
	}

</style>
<style scoped>
	body .el-popover {
		min-width: 50px;
		padding: 0;
	}

	[v-cloak] {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ceping/yixiaolie.vue